export { default as translations } from './translations.json';

export const MAX_QA = 50;
export const MAX_QUESTION_LENGTH = 500;

/**
 * Filter to only answered questions.
 * @param {Object[]} qa
 * @returns {Object[]}
 */
export const getAnsweredQuestions = (qa) =>
  Array.isArray(qa) ? qa.filter(q => q.answer !== null) : [];

/**
 * Get unanswered questions.
 * @param {Object[]} qa
 * @returns {Object[]}
 */
export const getUnansweredQuestions = (qa) =>
  Array.isArray(qa) ? qa.filter(q => q.answer === null) : [];
